import { LAB_ABBREVIATIONS } from "@/configuration/lab-abbreviations";
import type { FieldTransformConfig } from "@/configuration/transform-config";

export const HEARTPLACE_TRANSFORM_CONFIG: FieldTransformConfig = {
  // Three shortest lab names, abbreviated, commas removed; none dropped to fit.
  listOfNameOfLabs: {
    maxLength: Number.POSITIVE_INFINITY,
    maxRange: 3,
    abbreviations: LAB_ABBREVIATIONS,
    priorityAbbreviations: [],
    selectShortest: true,
    stripCommas: true,
  },
};
